module.exports = __webpack_public_path__ + "static/media/02_web_marketing-actu-franchise.5eeddaa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_marketing-actu-franchise.jpg
// module id = 62
// module chunks = 0